import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails, PaymentResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";

export class GetPaymentMethodsByPaxCommand extends IRequestCommand<
  IGetPaymentMethodsByPaxCommandCommandResponse,
  ErrorDetails,
  IGetPaymentMethodsByPaxCommandCommandParameters
> {
    override _commandType: CommandRequestType = CommandRequestType.POST;
    override _commandUrl = 'carriers/{carrierId}/paymentMethodsByPax';
    
    public setUrlParameter(carrierId: string) {
        this._commandUrl = this._commandUrl.replace(
            '{carrierId}',
            carrierId
        );
    }

    public override setParameters(parameters: IGetPaymentMethodsByPaxCommandCommandParameters) {
        this._commandBody = parameters;
    }
}

export interface IGetPaymentMethodsByPaxCommandCommandParameters
  extends ICommandParameters {
    passengerId: number;
    typeConfig: string;
}

export interface IGetPaymentMethodsByPaxCommandCommandResponse
  extends ICommandResponse, PaymentResponseDTO {

}
